/* Random color for bacground and text */
export const colors = [
  '#50796d','#FF6F61','#9B1B30','#77212E','#dd713c',
  '#fa9a85','#5a3e36', '#ce5b78','#935529','#e08119', '#2a4b7c','#577284',
  '#f96714','#264e36','#d79728','#2a293e','#9f9c99', '#797b3a','#dd4132',
  '#9e1030','#fe840e','#c62168','#8d9440','#ffd662','#00539c'
];

/* Random font-family for text */
export const font = [
  "'Balsamiq Sans', cursive",
  "'Open Sans', sans-serif",
  "'Roboto', sans-serif",
  "monospace"
];

/* Background color better suited for black fonts */
export const betterWithBlack = [
  '#FF6F61','#DF7B49','#fa9a85','#D98197','#e08119','#F96C1A','#d79728',
  '#9f9c99','#999C49','#E7746A','#fe840e','#ffd662'
];